import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "../components/Button";
import Input from "../components/Input";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // pobieramy token z URL
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [respMessage, setRespMessage] = useState({message:"",success:false});
    const [visrespMessage, setVisRespMessage] = useState(false);

  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {


    const checkToken = async () => {
      try {
       // console.log("Token:", token);
        const res = await fetch("https://hs2api.razamit.pl/resetpassword", {
          method: "POST",
      
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });

        if (!res.ok) {
          const data = await res.json();
          setRespMessage({message:data.message ,success:data.success});
          return;
        }


        const data = await res.json();
      
      } catch (err) {
        setVisRespMessage(true);
        setRespMessage({message:"Wystąpił błąd. Spróbuj ponownie.",success:false});
        console.error(err);
      }
    };

    checkToken();
    if (!token) {
      setRespMessage({message:"Link jest nieprawidłowy lub wygasł.",success:false});
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setRespMessage("");


    if (password !== passwordConfirm) {
      setRespMessage("Hasła nie są zgodne.",false);
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch("https://hs2api.razamit.pl/resetPass", {
        method: "POST",
      
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });

      if (!res.ok) {
        const data = await res.json();
        setRespMessage(data.message || "Błąd serwera.",false);
        return;
      }

      setRespMessage("Hasło zostało zmienione pomyślnie!",true);
      setTimeout(() => navigate("/login", { replace: true }), 1000); // przekierowanie po 3s
    } catch (err) {
      setRespMessage("Wystąpił błąd. Spróbuj ponownie.",false);
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-blue-950 to-gray-800 px-4">
    
        

        
        {visrespMessage ? (
           
          
          <div className={`mb-4 text-center border ${respMessage.success ? "text-green-600  border-green-300" : "text-red-600 bg-red-50  border-red-300"}  p-2 rounded-md`}>
          {respMessage.message}
          </div>
        ) : (
  <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-6 sm:p-8">
        <h1 className="text-2xl font-bold mb-4 text-center">Reset hasła</h1>

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Nowe hasło"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
            />
            <Input
              label="Powtórz hasło"
              type="password"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              fullWidth
            />
            <Button
              type="submit"
              disabled={submitting || !token}
              className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white"
            >
              {submitting ? "Przetwarzanie..." : "Zmień hasło"}
            </Button>
          </form>
           </div>
  
        )}
        </div>
     
  );
}
